var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "700px",
    viewBox: "0 0 800 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882354%,52.156866%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 800 357.753906 C 800 329.058594 797.277344 308.121094 791.382812 286.40625 L 408.164062 286.40625 L 408.164062 415.921875 L 633.105469 415.921875 C 628.570312 448.109375 604.082031 496.578125 549.660156 529.152344 L 548.894531 533.488281 L 670.0625 613.75 L 678.457031 614.464844 C 755.554688 553.582031 800 464.003906 800 357.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,65.882355%,32.549021%)",
      fillOpacity: 1
    },
    d: "M 408.164062 699 C 518.367188 699 610.882812 667.976562 678.457031 614.464844 L 549.660156 529.152344 C 515.191406 549.703125 468.933594 564.050781 408.164062 564.050781 C 300.226562 564.050781 208.617188 503.171875 175.960938 419.023438 L 171.175781 419.371094 L 45.183594 502.746094 L 43.535156 506.660156 C 110.65625 620.667969 248.523438 699 408.164062 699 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,73.725492%,1.960784%)",
      fillOpacity: 1
    },
    d: "M 175.960938 419.023438 C 167.34375 397.308594 162.359375 374.042969 162.359375 350 C 162.359375 325.957031 167.34375 302.691406 175.507812 280.976562 L 175.28125 276.351562 L 47.710938 191.640625 L 43.535156 193.335938 C 15.875 240.644531 0 293.773438 0 350 C 0 406.226562 15.875 459.351562 43.535156 506.660156 L 175.960938 419.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,26.274511%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 408.164062 135.945312 C 484.804688 135.945312 536.503906 164.253906 565.984375 187.910156 L 681.175781 91.738281 C 610.429688 35.511719 518.367188 1 408.164062 1 C 248.523438 1 110.65625 79.332031 43.535156 193.335938 L 175.507812 280.976562 C 208.617188 196.828125 300.226562 135.945312 408.164062 135.945312 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.19154ee78b9e405a70b578075164f3da.svg";
export { ForwardRef as ReactComponent };